module.exports = __webpack_public_path__ + "static/media/close-outline.a6d8df32.svg";